import React from 'react';

interface Props {
  children: React.ReactNode;
  overflowY?: 'auto' | 'hidden' | 'scroll' | 'visible' | 'initial' | 'inherit';
  overflowX?: 'auto' | 'hidden' | 'scroll' | 'visible' | 'initial' | 'inherit';
  height?: string;
  id: string;
}

const CustomModalWrapper = ({
  children,
  overflowY,
  overflowX,
  height,
  id,
}: Props) => {
  return (
    <div
      id={id}
      style={{
        // height: height ? height : 'calc(100vh - 200px)',
        maxHeight: height ? height : 'calc(100vh - 200px)',
        overflow: 'auto',
        overflowX: overflowX ? overflowX : 'hidden',
        overflowY: overflowY && overflowY,
        position: 'relative',
      }}
    >
      {children}
    </div>
  );
};

export default CustomModalWrapper;
